import { motion } from "framer-motion";
import { HIGHLIGHTS } from "@/lib/constants";

export const Highlights = () => {
  return (
    <section id="highlights" className="relative py-24 md:py-32 border-t border-white/5" data-testid="highlights-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-20 max-w-3xl"
        >
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-5 ">Project Highlights</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F8F6F0] leading-[1.05] tracking-tight">
            An address built for{" "}
            {/* <span className="italic gold-text"> ambition.</span> */}
            <span className="italic bg-gradient-to-r from-[#ffb413] via-[#D4AF37] to-[#ff9900] text-transparent bg-clip-text">
              Ambition.
            </span>
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{ show: { transition: { staggerChildren: 0.18 } } }}
          className="grid md:grid-cols-3 gap-6 md:gap-8"
        >
          {HIGHLIGHTS.map((h) => (
            <motion.div
              key={h.n}
              variants={{
                hidden: { opacity: 0, y: 40 },
                show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
              }}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
              className="group relative overflow-hidden bg-[#0A0A0B] border border-white/10 hover:border-[#D4AF37]/40 transition-colors duration-500 p-8 md:p-10 min-h-[320px]"
              data-testid={`highlight-card-${h.n}`}
            >
              {/* Giant numeral */}
              <div className="absolute -top-6 -right-2 font-serif italic text-[12rem] leading-none text-[#D4AF37]/[0.06] select-none pointer-events-none">
                {h.n}
              </div>
              <div className="relative z-10">
                <div className="font-mono text-xs tracking-[0.3em] text-[#D4AF37] mb-6">{h.n}</div>
                <h3 className="font-serif text-3xl md:text-4xl text-[#F8F6F0] leading-tight tracking-tight">
                  {h.title}
                </h3>
                <div className="mt-6 h-px w-12 bg-[#D4AF37] group-hover:w-24 transition-all duration-500" />
                <p className="mt-6 text-sm md:text-base text-[#A0A0A0] font-light leading-relaxed">
                  {h.body}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
